import gsap, { Expo, Power2, Power3, Power4 } from 'gsap';
import { GetBy } from '../_app/cuchillo/core/Element';
import Keyboard, { KEYS } from '../_app/cuchillo/core/Keyboard';
import { Metrics } from '../_app/cuchillo/core/Metrics';
import { Sizes } from '../_app/cuchillo/core/Sizes';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import { Maths } from '../_app/cuchillo/utils/Maths';
import VideoMultiple from './VideoMultiple';
import { Functions } from '../_app/cuchillo/utils/Functions';
import EventDispatcher from '../_app/cuchillo/core/EventDispatcher';
import { Interaction } from '../_app/cuchillo/core/Interaction';
import { id } from 'date-fns/locale';
import { isSmartphone } from '../_app/cuchillo/core/Basics';

const LIMIT_RADIAN = 6.28;
const CircleVisorConfig = {
  fontStyle: {
    font: "PPNeueMontreal",
    align: "left"
  },
  cabezal: {
    width: 1.5 * Sizes.RATIO
  },
  color: "#FFFF2B",
  options: {
    size_normal: .8,
    size_normal_stroke: 2,
    size_visor: .75,
    size_visor_stroke: .25,
    size_contact: .6,
    size_contact_stroke: 1,
    size_hide: 1.5,
    size_hide_stroke: 0,
  },
  easing: .1,
  speedMod: 1
};

export default class CircleVisor {
  static state = "HIDE"
  static mouse;
  static width;
  static height;
  static stroke;
  static strokeTo = 0;
  static sizeImage;
  static scaleImage = 1;
  static scaleImageTo = 1;
  static radioTo = 0;
  static alpha = 0;
  static _radio;
  static preloadProgress = 0;
  static isPreload = true;
  static get radio() { return this._radio; }
  static set radio(__radio) {
    this._radio = __radio;

    const s = Math.max(this._radio, this.stroke);
    const radioExterior = this._radio + s / 2;
    const radioInterior = this._radio - s / 2;
    const area = 0.5 * (radioExterior ** 2 - radioInterior ** 2);
    const temp = Math.sqrt(area) * 1.1 * this.scaleImage;
    this.sizeImage = [temp, temp * .5];
  }

  static isEnabled = false;
  static canvas = {
    front: GetBy.id("CanvasFront"),
    back: GetBy.id("CanvasBack"),
  };

  static ctx = {
    front: CircleVisor.canvas.front.getContext('2d'),
    back: CircleVisor.canvas.back.getContext('2d'),
  };

  static sizes = {}
  static position = {}
  
  static _rotation = 0;
  static get rotation() {return this._rotation; }
  static set rotation(_rotation) {
    
    if(_rotation > LIMIT_RADIAN) {
      this._rotation = 0 + _rotation - LIMIT_RADIAN;
    } else if(_rotation < 0) {
      this._rotation = LIMIT_RADIAN + _rotation;
    } else {
      this._rotation = _rotation;
    }
  }
  
  static speed = 0;
  static angleItem = 0;
  static items = [];
  static cabezal;
  static total;
  static get progress() { return this.cabezal.progress; }
  static set progress(__n) {
    this.cabezal.progress = __n;
  }

  static onMouseOver;
  static onMouseOut;
  static onItemMouseOver;
  static onItemMouseOut;
  static cabezalSize = 0;
  static cabezalAlpha = 0;
  static cabezales = [];
  static total_cabezales = 0;

  static init() {
    [...GetBy.class("__circle_item")].map(dom => {     
      this.items.push(new CircleVisor_Quesito(dom, this.items.length));
    })

    this.cabezal = new CircleVisor_Cabezal(this.ctx.front);

    this.total = this.items.length;
    this.angleItem = (Math.PI * 2) / this.total;
    this.angleItemHalf = this.angleItem * .5;

    this.resize();
    this.isEnabled = true;
    
    EventDispatcher.addEventListener("FOCUS_ON", () => { CircleVisor.goFocus(); }, "CIRCLE");
    EventDispatcher.addEventListener("FOCUS_OFF", () => { CircleVisor.goNormal(); }, "CIRCLE");
  }

  static addCabezales(__items,) {
    for(let i = 0,j=__items.length; i<j; i++) {
      const c = new CircleVisor_Cabezal(this.ctx.front, true);
      c.progress = (1/__items.length) * i;
      c.setText(__items[i].dataset.name,__items[i].dataset.role,"");
      this.total_cabezales = this.cabezales.push(c);
    }
  }

  static disposeCabezales() {
    for(let i = 0,j= this.total_cabezales; i<j; i++) {
      this.cabezales[i].dispose();
    }

    this.total_cabezales = 0;
    this.cabezales = [];
  }

  static reset() {
      if(!this.items.length) {
        [...GetBy.class("__circle_item")].map(dom => {     
        this.items.push(new CircleVisor_Quesito(dom, this.items.length));
      })

      this.total = this.items.length;
      this.angleItem = (Math.PI * 2) / this.total;
      this.angleItemHalf = this.angleItem * .5;

      this.resize();
    }
  }

  static disposeModeHome() {
    CircleVisor.onMouseOver = 
      CircleVisor.onMouseOut = 
        CircleVisor.onItemMouseOver = 
          CircleVisor.onItemMouseOut = null;
  }

  static mouseOver(__hasFocus) {
    if(this.isMouseOver == __hasFocus) return;

    this.isMouseOver = __hasFocus;

    if(this.isMouseOver) this.onMouseOver?.();
    else this.onMouseOut?.();
  }

  static goFocus() {
    this.state = "FOCUS";
    gsap.killTweensOf(this);
    gsap.to(this, { radio: this.sizes.visor, ease: Expo.easeOut, delay: 0, duration: 1 });
    gsap.to(this, { stroke: this.sizes.stroke_visor, scaleImage: 1, delay: 0, ease: Power3.easeOut, duration: .6 });
    gsap.to(this.cabezal, { size: this.sizes.cabezal * .5, delay: 0, ease: Power3.easeOut, duration: .6, onComplete:()=> {
       this.isHide = false;
    } });

  }

  static goNormal() {
    this.state = "NORMAL";
    gsap.killTweensOf(this);
    gsap.to(this, { radio: this.sizes.normal, ease: Power4.easeOut, duration: .6 });
    gsap.to(this, { stroke: this.sizes.stroke_normal, scaleImage: 1.2, ease: Power4.easeOut, duration: .6 });
    gsap.to(this.cabezal, { size: this.sizes.cabezal, ease: Power4.easeOut, duration: .6 });
  }

  static goContact() {
    this.state = "CONTACT";
    this.isHide = true;
    gsap.killTweensOf(this);
    //CircleVisorConfig.color = "#fff";
    CircleVisorConfig.speedMod = 10;
    
    gsap.to(this, { radio: this.sizes.contact, ease: Expo.easeOut, duration: 1 });
    gsap.to(this, { stroke: this.sizes.stroke_normal, scaleImage: 1.2, delay:.4, ease: Power3.easeOut, duration: .8});
    gsap.to(this, { alpha: 1, delay:.2, ease: Power3.easeOut, duration: .4});
    gsap.to(this, { cabezalAlpha:1, ease: Power3.easeIn, delay:.6, duration: .2});
    gsap.to(this, { cabezalSize: this.sizes.cabezal, ease: Power3.easeInOut, delay:.4, duration: .8});
  }

  static hide(__call) {
    this.state = "HIDE";
    this.isHide = true;
    gsap.killTweensOf(this);
    gsap.to(this, { radio: this.sizes.hide, ease: Power2.easeIn, duration: 1 });
    gsap.to(this, { stroke: 10, scaleImage: 1.2, delay:.3, ease: Power3.easeOut, duration: .8});
    gsap.to(this, { alpha: 0, delay:.3, ease: Power3.easeOut, duration: .4});
    gsap.to(this.cabezal, { alpha:0, ease: Power3.easeOut, delay:0, duration: .2});
    gsap.to(this, { cabezalAlpha:0, ease: Power3.easeOut, delay:0, duration: .2});
    gsap.to(this, {cabezalSize: 0, ease: Power2.easeOut, delay:0, duration: .4});
    gsap.to(this.cabezal, {size: 0, ease: Power2.easeOut, delay:0, duration: .4, onComplete:() => {
      if(__call) __call();
    } });
  }

  static show(__call) {
    this.state = "HIDE";
    this.isHide = true;
    gsap.killTweensOf(this);
    CircleVisorConfig.color = "#FFFF2B";
    CircleVisorConfig.speedMod = 1;

    if(this.isPreload) {
      this.stroke = this.sizes.stroke_normal;
      this.radio = this.sizes.normal;
      this.alpha = 1;
      this.isPreload = false;
      gsap.to(this.cabezal, { alpha:1, ease: Power3.easeIn, delay:.4, duration: .4});
      gsap.to(this.cabezal, { size: this.sizes.cabezal, ease: Expo.easeInOut, delay:0, duration: 2, onComplete:() => {
        if(__call) __call();
      } });
      return;
    }
    
    gsap.to(this, { radio: this.sizes.normal, ease: Expo.easeOut, duration: 1 });
    gsap.to(this, { stroke: this.sizes.stroke_normal, scaleImage: 1.2, delay:.4, ease: Power3.easeOut, duration: .8});

    gsap.to(this, { alpha: 1, delay:.2, ease: Power3.easeOut, duration: .4});
    gsap.to(this.cabezal, { alpha:1, ease: Power3.easeIn, delay:.6, duration: .2});
    gsap.to(this.cabezal, { size: this.sizes.cabezal, ease: Power3.easeInOut, delay:.4, duration: .8, onComplete:() => {
      if(__call) __call();
    } });
  }

  static select(__n) {
    this.items[__n].activate();
  }

  static loop() {
    this.clearCanvas();

    if(this.isPreload) {
      this.ctx.front.globalAlpha = 1;
      this.stroke = this.sizes.stroke_normal;
      this.radio = this.sizes.normal;
      this.drawPreload(this.position.x,this.position.y,this.radio,this.stroke,this.preloadProgress);
      this.ctx.front.globalAlpha = CircleVisor.alpha;
      return;
    }

    if(!this.isEnabled) return;

    //UPDATE VALUES
    this.rotation = this.rotation + (this.speed * CircleVisorConfig.speedMod) * -1;
    this.mouse = {
      x: Interaction.positions.mouse.x * Sizes.RATIO,
      y: Interaction.positions.mouse.y * Sizes.RATIO
    }
    
    this.ctx.front.globalAlpha = CircleVisor.alpha;

    //CHECK MOUSE AND GET RELATIVE ANGLE
    const angle = this.checkMousePosition();
    let itemActive = null;
    //UPDATE QUESITOS
    for (let i = 0; i < this.total; i++) {
      if(this.items[i].checkActive(i, angle, this.angleItem)) itemActive = this.items[i];
      this.items[i].draw(this.ctx,i,this.position.x,this.position.y + Scroll.y * Sizes.RATIO, this.radio,this.stroke,this.rotation,this.angleItem, this.angleItemHalf)
    }

    if(itemActive) this.onItemMouseOver?.(itemActive);
    
    //UPDATE CABEZAL
    this.cabezal.draw(this.ctx,this.position.x,this.position.y + Scroll.y * Sizes.RATIO, this.radio,this.stroke);

    //UPDATE CABEZALES
    
    for(let i = 0,j= this.total_cabezales; i<j; i++) {
      const c = this.cabezales[i];
      
      c.draw(this.ctx,this.position.x,this.position.y + Scroll.y  * Sizes.RATIO,this.radio,this.stroke);
    }
  }

  static drawPreload(x,y,radio,stroke,progress) {
    if(progress < 0.01) return;

    radio = (radio * .7) +  (radio * .3) * progress;
    
    const halfStroke = stroke * 0.5;
    const ctx = this.ctx.front;
    const startAngle = 7 * progress -Math.PI / 2; 
    const endAngle = startAngle + progress * Math.PI * 2;

    ctx.beginPath();
    ctx.arc(x, y, radio, startAngle, endAngle, false);
    ctx.strokeStyle = CircleVisorConfig.color
    ctx.lineWidth = stroke;
    ctx.lineCap = "round"; // opcional, para bordes suaves
    ctx.stroke();
    ctx.closePath();
  }

  static checkMousePosition() {
    if(this.isHide) return;

    const pointDistanceFromCenter = {
      x: CircleVisor.mouse.x - CircleVisor.position.x,
      y: CircleVisor.mouse.y - CircleVisor.position.y
    }
    const distanceFromCenter = Math.sqrt(pointDistanceFromCenter.x*pointDistanceFromCenter.x + pointDistanceFromCenter.y*pointDistanceFromCenter.y);

    const inner = CircleVisor.radio - CircleVisor.stroke/2;
    const outer = CircleVisor.radio + CircleVisor.stroke/2;

  
    //Esta fuera del diametro
    if(distanceFromCenter > outer) {
        this.mouseOver(false);
        return false;
    }

    this.mouseOver(true);
    
    //Esta fuera del anillo
    if (distanceFromCenter < inner) {
      return false;
    }
       
    let angle = Math.atan2(pointDistanceFromCenter.y, pointDistanceFromCenter.x);
    if (angle < 0) angle += Math.PI * 2;

    return angle;
  }

  static resize() {
    const newW = this.canvas.front.offsetWidth * Sizes.RATIO;
    const newH = this.canvas.front.offsetHeight * Sizes.RATIO;

    console.log(newW,newH,this.width,this.height)

    if(this.width == newW && this.height == newH) return;

    this.width = newW;
    this.height = newH;

    this.position = {
      x: Metrics.CENTER_X * Sizes.RATIO,
      y: Metrics.CENTER_Y * Sizes.RATIO,
    }

    this.sizes = {
      normal: Math.min(Metrics.CENTER_X, Metrics.CENTER_Y) * CircleVisorConfig.options.size_normal * Sizes.RATIO,
      stroke_normal: CircleVisorConfig.options.size_normal_stroke * Sizes.RATIO,
      visor: Math.min(Metrics.CENTER_X, Metrics.CENTER_Y) * CircleVisorConfig.options.size_visor * Sizes.RATIO,
      stroke_visor: Math.min(Metrics.CENTER_X, Metrics.CENTER_Y) * CircleVisorConfig.options.size_visor_stroke * Sizes.RATIO,
      contact: Math.min(Metrics.CENTER_X, Metrics.CENTER_Y) * CircleVisorConfig.options.size_contact * Sizes.RATIO,
      stroke_contact: CircleVisorConfig.options.size_contact_stroke * Sizes.RATIO,
      hide: Math.min(Metrics.CENTER_X, Metrics.CENTER_Y) * CircleVisorConfig.options.size_hide * Sizes.RATIO,
      stroke_hide: CircleVisorConfig.options.size_hide_stroke * Sizes.RATIO,
      font_sans_size: Math.min(16, Metrics.parseSize("16fpx")) * Sizes.RATIO,
      font_mono_size: Math.min(10, Metrics.parseSize("10fpx"))  * Sizes.RATIO,
      font_margin: Math.min(16, Metrics.parseSize("16fpx"))  * Sizes.RATIO,
      cabezal_margin: Math.min(40, Metrics.parseSize("40fpx"))  * Sizes.RATIO
    }

    this.sizes.cabezal = this.sizes.stroke_visor * 1;

    switch(this.state) {
      case "FOCUS":
        this.stroke = this.sizes.stroke_visor;
        this.radio = this.sizes.normal;
        this.cabezal.size = this.sizes.cabezal;
        break;
      case "NORMAL":
        this.stroke = this.sizes.stroke_normal;
        this.radio = this.sizes.normal;
        this.cabezal.size = this.sizes.cabezal;
        break;
      case "CONTACT":
        this.stroke = this.sizes.stroke_contact;
        this.radio = this.sizes.contact;
        this.cabezal.size = this.sizes.cabezal;
        break;
      case "HIDE":
      
        this.stroke = this.sizes.stroke_hide;
        this.radio = this.sizes.hide;
        this.cabezal.size = 0;
        break;
    }
    
    ["front", "back"].forEach(canvasType => {
      this.canvas[canvasType].setAttribute('width', this.width);
      this.canvas[canvasType].setAttribute('height', this.height);
    });

  }

  static clearCanvas() {
    this.ctx.front.clearRect(0, 0, this.width, this.height);
    this.ctx.back.clearRect(0, 0, this.width, this.height);
  }
}

class CircleVisor_Quesito {
  constructor(dom,index) {
    this.index = index;
    this.video = dom.querySelector("videxo") || null;
    this.image = new Image();
    this.data = dom.dataset;
    this.image.src = this.data.image;
    this.alphaImage = 1;
    this.isActive = false;
    this.ratio = this.data.height/this.data.width;

    if (this.video) {
      this.video.muted = true;   // evita bloqueos de autoplay
      this.video.loop = true;
      this.video.play().catch(err => {
        console.warn("No se pudo reproducir el video automáticamente:", err);
      });
    }
  }

  activate() {
    if(this.isActive) return;

    gsap.killTweensOf(this.alpha);
    this.alphaImage = 0;
    gsap.to(this,{alphaImage:1, delay:0, ease: Power3.easeIn, duration:.3});
    CircleVisor.cabezal.setText(this.data.title, this.data.client,);
  }

  draw(ctx, index, x, y, radio, stroke, rotation, angleItem, angleItemHalf) {
    const start = rotation + index * angleItem;
    const end = start + angleItem;
    const halfStroke = stroke * 0.5;
    
    const midAngle = start + angleItemHalf;
    const px = x + radio * Math.cos(midAngle);
    const py = y + radio * Math.sin(midAngle);
    const alphaByStroke = Math.max(0, Maths.normalize(60, 10, stroke));

    this.boundingBox = {
      x: px - CircleVisor.sizeImage[1],
      y: py - CircleVisor.sizeImage[1],
      width: CircleVisor.sizeImage[0],
      height: CircleVisor.sizeImage[0]
    };
    
    ctx.front.save();
    ctx.front.beginPath();
    ctx.front.arc(x, y, radio + halfStroke, start, end);
    ctx.front.arc(x, y, radio - halfStroke, end, start, true);
    ctx.front.fillStyle = CircleVisorConfig.color;
    ctx.front.fill();
    ctx.front.closePath();
    ctx.front.clip();
    ctx.front.globalAlpha = Math.min(CircleVisor.alpha, Math.min(alphaByStroke, this.alphaImage));

    // Si hay video con frames listos → dibuja video
    if (this.video && this.video.readyState >= 2) {
      ctx.front.drawImage(
        this.video,
        this.boundingBox.x,
        this.boundingBox.y,
        this.boundingBox.width * this.ratio,
        this.boundingBox.height * this.ratio
      );
    }
    // Si no, dibuja imagen
    else if (this.image.complete) {
      ctx.front.drawImage(
        this.image,
        this.boundingBox.x,
        this.boundingBox.y,
        this.boundingBox.width,
        this.boundingBox.height
      );
    }

    ctx.front.restore();
  }

  checkActive(index, angle, angleItem) {
    return;
    // ángulo del quesito
    const start = (CircleVisor.rotation + index * angleItem) % (Math.PI * 2);
    const end   = (start + angleItem) % (Math.PI * 2);

    let isActive;
    if (start < end) {
      isActive = angle >= start && angle <= end;
    } else {
      isActive = angle >= start && angle <= end;
    }

    if(isActive) {
      this.activate();
    }

    this.isActive = isActive;

    return isActive;
  }
}

class CircleVisor_Cabezal {
  get progress() { return this._progress; }
  set progress(value) {
    if (value > 1) {
      this._progress = value - 1;
    } else if (this.progress < 0) {
      this._progress = 1 + value;
    } else {
      this._progress = value;
    }
  }

  constructor(ctx,isFree = false) {
    this.isFree = isFree;
    this.size = .5;
    this.size2 = .5;
    this.ctx = ctx;
    this.progress = 0; // valor entre 0 y 1
    this.alignTo = "left";
    this.align = "left";
    this.texts = ["","",""]; 
    this.alpha = 0;
  }

  setText(text1, text2, text3) {
    this.texts[0] = text1.trim();
    this.texts[1] = text2.trim();
    if(text3) this.texts[2] = text3.trim();
    this.align = this.alignTo;
  }

  setTimerText(__text) {
    this.texts[2] = __text;
  }

  draw(ctx, x, y, radio, stroke) {
    const rotation = (this.progress) * Math.PI * 2 + CircleVisor.rotation;
    const stke = this.isFree? Math.max(CircleVisor.cabezalSize, stroke) : Math.max(this.size, stroke);
    const halfStroke = stroke * .5;
    const p1Size = radio - stke * .5;
    const p2Size = radio + halfStroke - 1;


    const pLine1 = {
      x: x + p1Size * Math.cos(rotation),
      y: y + p1Size * Math.sin(rotation)
    }

    const pLine2 = {
      x: x + p2Size * Math.cos(rotation),
      y: y + p2Size * Math.sin(rotation),
    }

    const pText = {
      x: x + (radio + halfStroke + CircleVisor.sizes.cabezal_margin) * Math.cos(rotation),
      y: y + (radio + halfStroke + CircleVisor.sizes.cabezal_margin) * Math.sin(rotation)
    }

    if(this.isFree) {
      this.align = Math.cos(rotation) >= 0 ? "left" : "right";
    } else {
      this.alignTo = Math.cos(rotation) >= 0 ? "left" : "right";
    }

    ctx.front.save();
    ctx.front.globalAlpha = this.isFree? CircleVisor.cabezalAlpha : this.alpha;

    let modFont = 1;
    if(isSmartphone) {
      pText.x = Metrics.CENTER_X * Sizes.RATIO;
      pText.y = Metrics.CENTER_Y * Sizes.RATIO;
      modFont = .8;
    }

    this._drawLine(pLine1,pLine2);    
    this._drawText(this.texts[0], pText.x, pText.y - CircleVisor.sizes.font_margin*modFont, "middle", this.align, `${CircleVisor.sizes.font_sans_size * modFont}px PPNeueMontreal`);
    this._drawText(this.texts[1], pText.x, pText.y, "middle", this.align, `${CircleVisor.sizes.font_sans_size*modFont}px PPNeueMontreal`);
    this._drawText(`${this.texts[2]}`, pText.x, pText.y + CircleVisor.sizes.font_margin*1*modFont, "middle", this.align, `${CircleVisor.sizes.font_mono_size * modFont}px Soehne Mono`);   

    ctx.front.restore();
    return;
  }

  _drawLine(p1, p2) {
    this.ctx.beginPath();
    this.ctx.moveTo(p1.x, p1.y);
    this.ctx.lineTo(p2.x, p2.y);
    this.ctx.strokeStyle = CircleVisorConfig.color;
    this.ctx.lineWidth = CircleVisorConfig.cabezal.width;
    this.ctx.stroke();
  }

  _setupText(_text) {
    const text = _text.toUpperCase().trim();
    console.log(text,"-")
    const metrics = this.ctx.measureText(text);
    const width = metrics.width;
    const center = metrics.width * .5;

    return { text, width, center }
  }

  _drawText(text, x, y, baseline, align = null, font = null) {
    if(isSmartphone) {
      align = "center";
    }

    this.ctx.fillStyle = CircleVisorConfig.color;
    this.ctx.font = font || CircleVisorConfig.fontStyle.font;
    this.ctx.textAlign = align || CircleVisorConfig.fontStyle.align;
    this.ctx.textBaseline = baseline;
    this.ctx.fillText(text, x, y);
  }

  dispose() {
    // Limpiar textos
    this.texts = null;

    // Quitar referencia al contexto
    this.ctx = null;

    // Resetear valores
    this._progress = null;
    this.alpha = null;
    this.align = null;
    this.alignTo = null;
    this.size = null;
    this.size2 = null;
  }
}